export function numberInt(value: string): number {
    return Math.trunc(Number(value));
}
